<template>
  <div class="template-container">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="模板名称">
          <el-input v-model="searchForm.templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-select v-model="searchForm.templateType" placeholder="请选择模板类型" clearable>
            <el-option label="裁决书" :value="1"></el-option>
            <el-option label="结案文书" :value="2"></el-option>
            <el-option label="笔录" :value="3"></el-option>
            <el-option label="其他" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <el-button type="primary" @click="handleAdd">新增模板</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="templateName" label="模板名称" min-width="200"></el-table-column>
      <el-table-column prop="tenantName" label="所属单位" min-width="160"></el-table-column>
      <el-table-column prop="templateType" label="模板类型" width="120">
        <template slot-scope="scope">
          {{ getTemplateTypeName(scope.row.templateType) }}
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive === 1 ? 'success' : 'info'">
            {{ scope.row.isActive === 1 ? '有效' : '无效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            :disabled="scope.row.hasDocuments"
            @click="handleDelete(scope.row)"
          >删除</el-button>
          <el-button
            v-if="scope.row.hasDocuments"
            size="mini"
            type="text"
            @click="handleToggleStatus(scope.row)"
          >{{ scope.row.isActive === 1 ? '置为无效' : '置为有效' }}</el-button>
          <el-button
            size="mini"
            type="text"
            @click="openBookmarkPage(scope.row)"
          >书签维护</el-button>
          <el-button
            size="mini"
            type="text"
            @click="handleDownload(scope.row)"
          >下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>

    <!-- 模板表单对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="form.templateName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="模板类型" prop="templateType">
          <el-select v-model="form.templateType" placeholder="请选择模板类型" style="width: 100%">
            <el-option label="裁决书" :value="1"></el-option>
            <el-option label="结案文书" :value="2"></el-option>
            <el-option label="笔录" :value="3"></el-option>
            <el-option label="其他" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属单位" prop="tenantId">
          <el-select v-if="isAdmin" v-model="form.tenantId" placeholder="请选择单位" filterable style="width:100%">
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId" />
          </el-select>
          <el-input v-else v-model="form.tenantName" :disabled="true" />
        </el-form-item>
        <el-form-item label="模板文件" prop="templateFile">
          <el-upload
            class="template-uploader"
            action="#"
            :auto-upload="false"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :on-exceed="handleExceed"
            accept=".docx"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传word文件（.doc/.docx），且不超过10MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="校对规则" prop="proofreadRule">
          <el-input
            type="textarea"
            v-model="form.proofreadRule"
            :rows="4"
            placeholder="请输入文书校对规则"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否有效" prop="isActive">
          <el-switch
            v-model="form.isActive"
            :active-value="1"
            :inactive-value="2"
            active-text="有效"
            inactive-text="无效"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 预览对话框 -->
    <el-dialog
      title="模板预览"
      :visible.sync="previewVisible"
      width="800px"
      class="preview-dialog"
    >
      <div class="preview-container">
        <iframe :src="previewUrl" frameborder="0"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getUserInfo } from '@/api/auth'
import { getTenantList } from '@/api/tenant'

export default {
  name: 'WritTemplate',
  data() {
    return {
      // 搜索表单
      searchForm: {
        templateName: '',
        templateType: null
      },
      // 加载状态
      loading: false,
      // 表格数据
      tableData: [],
      // 分页信息
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      // 对话框显示状态
      dialogVisible: false,
      // 对话框标题
      dialogTitle: '新增模板',
      // 表单数据
      form: {
        templateId: null,
        templateName: '',
        templateType: null,
        templateFile: null,
        proofreadRule: '',
        isActive: 1,
        tenantId: ''
      },
      // 表单验证规则
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ],
        templateType: [
          { required: true, message: '请选择模板类型', trigger: 'change' }
        ],
        tenantId: [
          { required: true, message: '请选择所属单位', trigger: 'change' }
        ],
        templateFile: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 新增时必须上传，编辑时fileList为空才校验
              if (!this.form.templateId && this.fileList.length === 0) {
                callback(new Error('请上传模板文件'));
              } else {
                callback();
              }
            }, trigger: 'change' }
        ],
        isActive: [
          { required: true, message: '请选择是否有效', trigger: 'change' }
        ]
      },
      // 文件上传列表
      fileList: [],
      // 提交状态
      submitting: false,
      // 预览相关
      previewVisible: false,
      // 预览URL
      previewUrl: '',
      // 上传相关
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      tenantOptions: [],
      currentUser: null,
    }
  },
  created() {
    this.fetchData()
    this.loadCurrentUserAndTenants()
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.roleType === 1
    }
  },
  methods: {
    async loadCurrentUserAndTenants() {
      // 获取当前用户
      const userRes = await getUserInfo()
      this.currentUser = userRes.data
      // 获取单位列表
      const tenantRes = await getTenantList({ pageNum: 1, pageSize: 1000 })
      this.tenantOptions = tenantRes.data.records || []
    },
    // 获取模板类型名称
    getTemplateTypeName(type) {
      const types = {
        1: '裁决书',
        2: '结案文书',
        3: '笔录',
        4: '其他'
      }
      return types[type] || '未知'
    },
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true
        const { current, size } = this.page
        const res = await request({
          url: '/api/template/page',
          method: 'get',
          params: {
            current,
            size,
            ...this.searchForm
          }
        })
        
        if (res.code === 200) {
          // 假设后端返回的每条数据有tenantId字段
          // 这里可以根据租户列表映射tenantName（如有租户列表可用）
          this.tableData = (res.data.records || []).map(item => {
            // 这里可根据实际租户列表做映射
            // 如 this.tenantOptions.find(t => t.tenantId === item.tenantId)?.tenantName
            return {
              ...item,
              tenantName: item.tenantName || item.tenantId // 后端如未返回tenantName则显示tenantId
            }
          })
          this.page.total = res.data.total
        }
      } catch (error) {
        console.error('获取模板列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    // 处理搜索
    handleSearch() {
      this.page.current = 1
      this.fetchData()
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        templateName: '',
        templateType: null
      }
      this.handleSearch()
    },
    // 处理新增
    handleAdd() {
      this.dialogTitle = '新增模板'
      // 兼容tenantOptions未加载好时的情况
      let tenantId = this.isAdmin ? '' : (this.currentUser ? this.currentUser.tenantId : '')
      let tenantName = ''
      if (Array.isArray(this.tenantOptions) && this.tenantOptions.length > 0 && tenantId) {
        const tenantObj = this.tenantOptions.find(t => t.tenantId === tenantId)
        tenantName = tenantObj ? tenantObj.tenantName : ''
      }
      this.form = {
        templateId: null,
        templateName: '',
        templateType: null,
        templateFile: null,
        proofreadRule: '',
        isActive: 1,
        tenantId: tenantId,
        tenantName: tenantName
      }
      this.fileList = []
      this.dialogVisible = true
    },
    // 处理编辑
    async handleEdit(row) {
      this.dialogTitle = '编辑模板'
      try {
        const res = await request({
          url: '/api/template/' + row.templateId,
          method: 'get'
        })
        
        if (res.code === 200) {
          let tenantId = this.isAdmin ? '' : (this.currentUser ? this.currentUser.tenantId : '')
          const tenant = this.tenantOptions.find(t => t.tenantId === (res.data.tenantId || tenantId))
          let tenantName = tenant ? tenant.tenantName : ''
          this.form = {
            ...res.data,
            tenantId: res.data.tenantId || tenantId,
            tenantName: tenantName
          }
          if (typeof this.form.isActive === 'undefined') this.form.isActive = 1
          this.fileList = res.data.templatePath ? [{ name: res.data.templateName, url: res.data.templatePath }] : []
          this.dialogVisible = true
        }
      } catch (error) {
        console.error('获取模板详情失败:', error)
      }
    },
    // 处理删除
    handleDelete(row) {
      this.$confirm('确认删除该模板吗？删除后相关书签也将被删除', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await request({
            url: '/api/template/' + row.templateId,
            method: 'delete'
          })
          
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.fetchData()
          }
        } catch (error) {
          console.error('删除模板失败:', error)
        }
      }).catch(() => {})
    },
    // 处理状态切换
    async handleToggleStatus(row) {
      try {
        const res = await request({
          url: '/api/template/toggle-status/' + row.templateId,
          method: 'put'
        })
        
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.fetchData()
        }
      } catch (error) {
        console.error('更新状态失败:', error)
      }
    },
    // 处理分页大小变化
    handleSizeChange(val) {
      this.page.size = val
      this.fetchData()
    },
    // 处理当前页变化
    handleCurrentChange(val) {
      this.page.current = val
      this.fetchData()
    },
    // 上传前校验
    beforeUpload(file) {
      const isWord = file.type === 'application/msword' || 
                    file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isWord) {
        this.$message.error('只能上传word文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },
    // 文件选择变化
    handleFileChange(file, fileList) {
      // 只保留有raw属性的文件（即新选择的文件）
      const newFileList = fileList.filter(f => f.raw)
      this.fileList = newFileList.slice(-1)
      if (this.fileList.length > 0) {
        this.form.templateFile = this.fileList[0]
      } else {
        this.form.templateFile = null
      }
    },
    handleExceed(files, fileList) {
      // files[0]是原生File对象，手动包装成el-upload的file对象格式
      this.fileList = [{
        name: files[0].name,
        raw: files[0],
        size: files[0].size,
        status: 'ready',
        uid: Date.now() + '',
        url: ''
      }]
      this.form.templateFile = this.fileList[0]
    },
    // 文件移除
    handleFileRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length === 0) {
        this.form.templateFile = null
      }
    },
    // 重置表单
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.fileList = []
    },
    // 提交表单
    async submitForm() {
      try {
        await this.$refs.form.validate()
        this.submitting = true
        const method = this.form.templateId ? 'put' : 'post'
        const formData = new FormData()
        const { templateId, templateName, templateType, proofreadRule, isActive, tenantId } = this.form
        formData.append('template', JSON.stringify({ templateId, templateName, templateType, proofreadRule, isActive, tenantId }))
        // 新增时必须有文件
        if (!this.form.templateId) {
          if (this.fileList.length === 0 || !(this.fileList[0].raw || this.fileList[0] instanceof File)) {
            this.$message.error('请上传模板文件')
            this.submitting = false
            return
          }
          const fileObj = this.fileList[0].raw ? this.fileList[0].raw : this.fileList[0]
          formData.append('file', fileObj)
        }
        // 编辑时，只有重新选择文件才上传
        if (this.form.templateId && this.fileList.length > 0 && (this.fileList[0].raw || this.fileList[0] instanceof File)) {
          const fileObj = this.fileList[0].raw ? this.fileList[0].raw : this.fileList[0]
          formData.append('file', fileObj)
        }
        const res = await request({
          url: '/template',
          method,
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (res.code === 200) {
          this.$message.success(this.form.templateId ? '更新成功' : '新增成功')
          this.dialogVisible = false
          this.fetchData()
        }
      } catch (error) {
        if (error === false) return // 表单验证失败
        console.error('提交表单失败:', error)
      } finally {
        this.submitting = false
      }
    },
    openBookmarkPage(row) {
      const base = `${window.location.origin}${window.location.pathname}#/bookmark-manage/${row.templateId}/${encodeURIComponent(row.templateName)}`;
      window.open(base, '_blank');
    },
    handleDownload(row) {
      // 直接下载后端接口返回的文件
      const url = `/api/template/download/${row.templateId}`
      // 兼容token
      const token = localStorage.getItem('token')
      const a = document.createElement('a')
      a.href = url + (token ? `?token=${token}` : '')
      a.target = '_blank'
      a.click()
    },
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  padding: 20px;

  .search-bar {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .toolbar {
    margin-bottom: 20px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .template-uploader {
    :deep(.el-upload-list) {
      width: 100%;
    }
  }
}

.preview-dialog {
  :deep(.el-dialog__body) {
    padding: 0;
  }

  .preview-container {
    height: 600px;
    
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style> 